import React from 'react';
import Header, { HeaderVariant } from 'shared/Header';
import { Footer } from 'components/Footer/Footer';
import styled from 'styled-components';
import Text, { TypeVariant } from 'shared/Typography';
import { buildImageUrl } from 'cloudinary-build-url';
import Image from 'next/image';

const Container = styled.section`
  background: black;
  min-height: 100vh;
  padding-top: var(--spacing-160);

  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding-top: var(--spacing-96);
  }
`;

const TitleWrap = styled.div`
  padding-bottom: var(--spacing-40);

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding-bottom: var(--spacing-32);
    max-width: 320px;
  }
`;

const InfoWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  margin-bottom: auto;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    flex-direction: column-reverse;
  }
`;

const TextWrap = styled.div`
  max-width: 800px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding: 60px 30px;
  }
`;

const ImageFullWidthWrap = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const getStaticProps = () => ({ props: {} });

const AboutUs = () => {
  const imageSrc = buildImageUrl('Group_3000_1_c4oegq', {
    transformations: {
      quality: 100,
    },
  });

  return (
    <div>
      <Header variant={HeaderVariant.dark} />

      <Container>
        <TitleWrap>
          <Text
            variant={TypeVariant.header03}
            as="h1"
            color="var(--color-white)"
            textAlign="center"
            tablet={TypeVariant.subtitle01}
          >
            A new place for fitness and community
          </Text>
        </TitleWrap>

        <InfoWrap>
          <TextWrap>
            <Text
              variant={TypeVariant.bodyLarge01}
              as="p"
              color="var(--color-white)"
              textAlign="center"
            >
              Solin empowers fitness creators to earn while building fitness
              communities that help people live better lives. Our name is
              derived from the Blue Zones concept developed by Dan Buettner. Dan
              discovered the five cities where people live the longest - the
              first letters of each of those cities make up our name. If we can
              help at all, please reach out to management@solinfitness.com.
            </Text>
          </TextWrap>
          <ImageFullWidthWrap>
            <Image
              src={imageSrc}
              alt="Picture of Solin cities"
              layout="responsive"
              width={3.5}
              height={1}
              priority
            />
          </ImageFullWidthWrap>
        </InfoWrap>

        <Footer background="#000" />
      </Container>
    </div>
  );
};

export default AboutUs;
